module.exports = __webpack_public_path__ + "img/index-app@2x.87d27084.png";